
import { useState } from 'react';
import emailjs from '@emailjs/browser';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';


function Contact() {
  {/* form Data */ }
  const countryCodes = [
    { name: "Afghanistan", dial_code: "+93", code: "AF" },
    { name: "Albania", dial_code: "+355", code: "AL" },
    { name: "Algeria", dial_code: "+213", code: "DZ" },
    { name: "Andorra", dial_code: "+376", code: "AD" },
    { name: "Angola", dial_code: "+244", code: "AO" },
    { name: "Antigua and Barbuda", dial_code: "+1-268", code: "AG" },
    { name: "Argentina", dial_code: "+54", code: "AR" },
    { name: "Armenia", dial_code: "+374", code: "AM" },
    { name: "Australia", dial_code: "+61", code: "AU" },
    { name: "Austria", dial_code: "+43", code: "AT" },
    { name: "Azerbaijan", dial_code: "+994", code: "AZ" },
    { name: "Bahamas", dial_code: "+1-242", code: "BS" },
    { name: "Bahrain", dial_code: "+973", code: "BH" },
    { name: "Bangladesh", dial_code: "+880", code: "BD" },
    { name: "Barbados", dial_code: "+1-246", code: "BB" },
    { name: "Belarus", dial_code: "+375", code: "BY" },
    { name: "Belgium", dial_code: "+32", code: "BE" },
    { name: "Belize", dial_code: "+501", code: "BZ" },
    { name: "Benin", dial_code: "+229", code: "BJ" },
    { name: "Bhutan", dial_code: "+975", code: "BT" },
    { name: "Bolivia", dial_code: "+591", code: "BO" },
    { name: "Bosnia and Herzegovina", dial_code: "+387", code: "BA" },
    { name: "Botswana", dial_code: "+267", code: "BW" },
    { name: "Brazil", dial_code: "+55", code: "BR" },
    { name: "Brunei", dial_code: "+673", code: "BN" },
    { name: "Bulgaria", dial_code: "+359", code: "BG" },
    { name: "Burkina Faso", dial_code: "+226", code: "BF" },
    { name: "Burundi", dial_code: "+257", code: "BI" },
    { name: "Cambodia", dial_code: "+855", code: "KH" },
    { name: "Cameroon", dial_code: "+237", code: "CM" },
    { name: "Canada", dial_code: "+1", code: "CA" },
    { name: "Cape Verde", dial_code: "+238", code: "CV" },
    { name: "Central African Republic", dial_code: "+236", code: "CF" },
    { name: "Chad", dial_code: "+235", code: "TD" },
    { name: "Chile", dial_code: "+56", code: "CL" },
    { name: "China", dial_code: "+86", code: "CN" },
    { name: "Colombia", dial_code: "+57", code: "CO" },
    { name: "Comoros", dial_code: "+269", code: "KM" },
    { name: "Congo (DRC)", dial_code: "+243", code: "CD" },
    { name: "Congo (Republic)", dial_code: "+242", code: "CG" },
    { name: "Costa Rica", dial_code: "+506", code: "CR" },
    { name: "Croatia", dial_code: "+385", code: "HR" },
    { name: "Cuba", dial_code: "+53", code: "CU" },
    { name: "Cyprus", dial_code: "+357", code: "CY" },
    { name: "Czech Republic", dial_code: "+420", code: "CZ" },
    { name: "Denmark", dial_code: "+45", code: "DK" },
    { name: "Djibouti", dial_code: "+253", code: "DJ" },
    { name: "Dominica", dial_code: "+1-767", code: "DM" },
    { name: "Dominican Republic", dial_code: "+1-809", code: "DO" },
    { name: "Ecuador", dial_code: "+593", code: "EC" },
    { name: "Egypt", dial_code: "+20", code: "EG" },
    { name: "El Salvador", dial_code: "+503", code: "SV" },
    { name: "Equatorial Guinea", dial_code: "+240", code: "GQ" },
    { name: "Eritrea", dial_code: "+291", code: "ER" },
    { name: "Estonia", dial_code: "+372", code: "EE" },
    { name: "Eswatini", dial_code: "+268", code: "SZ" },
    { name: "Ethiopia", dial_code: "+251", code: "ET" },
    { name: "Fiji", dial_code: "+679", code: "FJ" },
    { name: "Finland", dial_code: "+358", code: "FI" },
    { name: "France", dial_code: "+33", code: "FR" },
    { name: "Gabon", dial_code: "+241", code: "GA" },
    { name: "Gambia", dial_code: "+220", code: "GM" },
    { name: "Georgia", dial_code: "+995", code: "GE" },
    { name: "Germany", dial_code: "+49", code: "DE" },
    { name: "Ghana", dial_code: "+233", code: "GH" },
    { name: "Greece", dial_code: "+30", code: "GR" },
    { name: "Grenada", dial_code: "+1-473", code: "GD" },
    { name: "Guatemala", dial_code: "+502", code: "GT" },
    { name: "Guinea", dial_code: "+224", code: "GN" },
    { name: "Guinea-Bissau", dial_code: "+245", code: "GW" },
    { name: "Guyana", dial_code: "+592", code: "GY" },
    { name: "Haiti", dial_code: "+509", code: "HT" },
    { name: "Honduras", dial_code: "+504", code: "HN" },
    { name: "Hungary", dial_code: "+36", code: "HU" },
    { name: "Iceland", dial_code: "+354", code: "IS" },
    { name: "India", dial_code: "+91", code: "IN" },
    { name: "Indonesia", dial_code: "+62", code: "ID" },
    { name: "Iran", dial_code: "+98", code: "IR" },
    { name: "Iraq", dial_code: "+964", code: "IQ" },
    { name: "Ireland", dial_code: "+353", code: "IE" },
    { name: "Israel", dial_code: "+972", code: "IL" },
    { name: "Italy", dial_code: "+39", code: "IT" },
    { name: "Jamaica", dial_code: "+1-876", code: "JM" },
    { name: "Japan", dial_code: "+81", code: "JP" },
    { name: "Jordan", dial_code: "+962", code: "JO" },
    { name: "Kazakhstan", dial_code: "+7", code: "KZ" },
    { name: "Kenya", dial_code: "+254", code: "KE" },
    { name: "Kuwait", dial_code: "+965", code: "KW" },
    { name: "Kyrgyzstan", dial_code: "+996", code: "KG" },
    { name: "Laos", dial_code: "+856", code: "LA" },
    { name: "Latvia", dial_code: "+371", code: "LV" },
    { name: "Lebanon", dial_code: "+961", code: "LB" },
    { name: "Lesotho", dial_code: "+266", code: "LS" },
    { name: "Liberia", dial_code: "+231", code: "LR" },
    { name: "Libya", dial_code: "+218", code: "LY" },
    { name: "Lithuania", dial_code: "+370", code: "LT" },
    { name: "Luxembourg", dial_code: "+352", code: "LU" },
    { name: "Madagascar", dial_code: "+261", code: "MG" },
    { name: "Malawi", dial_code: "+265", code: "MW" },
    { name: "Malaysia", dial_code: "+60", code: "MY" },
    { name: "Maldives", dial_code: "+960", code: "MV" },
    { name: "Mali", dial_code: "+223", code: "ML" },
    { name: "Malta", dial_code: "+356", code: "MT" },
    { name: "Mauritania", dial_code: "+222", code: "MR" },
    { name: "Mauritius", dial_code: "+230", code: "MU" },
    { name: "Mexico", dial_code: "+52", code: "MX" },
    { name: "Moldova", dial_code: "+373", code: "MD" },
    { name: "Monaco", dial_code: "+377", code: "MC" },
    { name: "Mongolia", dial_code: "+976", code: "MN" },
    { name: "Montenegro", dial_code: "+382", code: "ME" },
    { name: "Morocco", dial_code: "+212", code: "MA" },
    { name: "Mozambique", dial_code: "+258", code: "MZ" },
    { name: "Myanmar", dial_code: "+95", code: "MM" },
    { name: "Namibia", dial_code: "+264", code: "NA" },
    { name: "Nepal", dial_code: "+977", code: "NP" },
    { name: "Netherlands", dial_code: "+31", code: "NL" },
    { name: "New Zealand", dial_code: "+64", code: "NZ" },
    { name: "Nicaragua", dial_code: "+505", code: "NI" },
    { name: "Niger", dial_code: "+227", code: "NE" },
    { name: "Nigeria", dial_code: "+234", code: "NG" },
    { name: "North Korea", dial_code: "+850", code: "KP" },
    { name: "North Macedonia", dial_code: "+389", code: "MK" },
    { name: "Norway", dial_code: "+47", code: "NO" },
    { name: "Oman", dial_code: "+968", code: "OM" },
    { name: "Pakistan", dial_code: "+92", code: "PK" },
    { name: "Palestine", dial_code: "+970", code: "PS" },
    { name: "Panama", dial_code: "+507", code: "PA" },
    { name: "Papua New Guinea", dial_code: "+675", code: "PG" },
    { name: "Paraguay", dial_code: "+595", code: "PY" },
    { name: "Peru", dial_code: "+51", code: "PE" },
    { name: "Philippines", dial_code: "+63", code: "PH" },
    { name: "Poland", dial_code: "+48", code: "PL" },
    { name: "Portugal", dial_code: "+351", code: "PT" },
    { name: "Qatar", dial_code: "+974", code: "QA" },
    { name: "Romania", dial_code: "+40", code: "RO" },
    { name: "Russia", dial_code: "+7", code: "RU" },
    { name: "Rwanda", dial_code: "+250", code: "RW" },
    { name: "Saudi Arabia", dial_code: "+966", code: "SA" },
    { name: "Senegal", dial_code: "+221", code: "SN" },
    { name: "Serbia", dial_code: "+381", code: "RS" },
    { name: "Seychelles", dial_code: "+248", code: "SC" },
    { name: "Sierra Leone", dial_code: "+232", code: "SL" },
    { name: "Singapore", dial_code: "+65", code: "SG" },
    { name: "Slovakia", dial_code: "+421", code: "SK" },
    { name: "Slovenia", dial_code: "+386", code: "SI" },
    { name: "Somalia", dial_code: "+252", code: "SO" },
    { name: "South Africa", dial_code: "+27", code: "ZA" },
    { name: "South Korea", dial_code: "+82", code: "KR" },
    { name: "South Sudan", dial_code: "+211", code: "SS" },
    { name: "Spain", dial_code: "+34", code: "ES" },
    { name: "Sri Lanka", dial_code: "+94", code: "LK" },
    { name: "Sudan", dial_code: "+249", code: "SD" },
    { name: "Suriname", dial_code: "+597", code: "SR" },
    { name: "Sweden", dial_code: "+46", code: "SE" },
    { name: "Switzerland", dial_code: "+41", code: "CH" },
    { name: "Syria", dial_code: "+963", code: "SY" },
    { name: "Taiwan", dial_code: "+886", code: "TW" },
    { name: "Tajikistan", dial_code: "+992", code: "TJ" },
    { name: "Tanzania", dial_code: "+255", code: "TZ" },
    { name: "Thailand", dial_code: "+66", code: "TH" },
    { name: "Togo", dial_code: "+228", code: "TG" },
    { name: "Trinidad and Tobago", dial_code: "+1-868", code: "TT" },
    { name: "Tunisia", dial_code: "+216", code: "TN" },
    { name: "Turkey", dial_code: "+90", code: "TR" },
    { name: "Turkmenistan", dial_code: "+993", code: "TM" },
    { name: "Uganda", dial_code: "+256", code: "UG" },
    { name: "Ukraine", dial_code: "+380", code: "UA" },
    { name: "United Arab Emirates", dial_code: "+971", code: "AE" },
    { name: "United Kingdom", dial_code: "+44", code: "GB" },
    { name: "United States", dial_code: "+1", code: "US" },
    { name: "Uruguay", dial_code: "+598", code: "UY" },
    { name: "Uzbekistan", dial_code: "+998", code: "UZ" },
    { name: "Vanuatu", dial_code: "+678", code: "VU" },
    { name: "Vatican City", dial_code: "+379", code: "VA" },
    { name: "Venezuela", dial_code: "+58", code: "VE" },
    { name: "Vietnam", dial_code: "+84", code: "VN" },
    { name: "Yemen", dial_code: "+967", code: "YE" },
    { name: "Zambia", dial_code: "+260", code: "ZM" },
    { name: "Zimbabwe", dial_code: "+263", code: "ZW" }
  ];
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    countryCode: "+1",
    phone: "",
    email: "",
    arrival: "",
    departure: "",
    adults: "",
    children: "",
    pageUrl: window.location.href,
    honeypot: "",
    message: ""
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    let newErrors = {};

    // Required fields
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Enter a valid email.";

    // Optional fields
    if (formData.phone && !/^[0-9]{7,15}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid phone number.";
    }
    if (formData.arrival) {
      const arrivalDate = new Date(formData.arrival);
      const today = new Date();
      if (arrivalDate < today) newErrors.arrival = "Arrival date cannot be in the past.";
    }
    if (formData.departure) {
      const departureDate = new Date(formData.departure);
      const today = new Date();
      if (departureDate < today) newErrors.departure = "Departure date cannot be in the past.";
    }
    if (formData.adults && formData.adults < 1) {
      newErrors.adults = "At least 1 adult required if specified.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.honeypot) {
      return;
    }
    if (validate()) {
      setLoading(true);
      emailjs
        .send(
          'service_7a7oaql',
          'template_n7du4w7',
          formData,
          'Qb8VI-rZV7Kpa7BFC'
        )
        .then(() => {
          setSubmitted(true);
          setFormData({
            name: "",
            countryCode: "+1",
            phone: "",
            email: "",
            arrival: "",
            departure: "",
            adults: "",
            children: "",
            pageUrl: window.location.href,
            honeypot: "",
            message: ""
          });
          setErrors({});
        })
        .catch(() => {

          alert("Something went wrong. Please try again.");
        })
        .finally(() => {
          setLoading(false);
          navigate("/ThankYou");
        });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div style={{
      position: "relative",
      zIndex: 100,
      backgroundImage: "var(--bg-image)",
      backgroundAttachment: "fixed",
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}>
      <Helmet>
        <title>Contact Us | African Travel Tour</title>
        <meta
          name="description"
          content="Get in touch with African Travel Tour to plan your next safari adventure. Contact our expert team for tailor-made itineraries, bookings, and inquiries."
        />
        <meta
          name="keywords"
          content="Contact African Travel Tour, safari booking Kenya, safari inquiries, travel agency contact"
        />
        <meta property="og:title" content="Contact Us | African Travel Tour" />
        <meta property="og:description" content="Reach out to African Travel Tour for safari bookings, inquiries, and tailor-made travel packages across Kenya and East Africa." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://africantraveltour.com/contact" />
      </Helmet>

      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="section-header text-white animated slideInDown mb-4">
                Contact Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    Contact
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {/* Contact Start */}
      <div className="container-xxl py-5">
        <div className="container">
          <h2 className="section-header mb-5 text-center">
            <span className="accent pulse-button">
             Get In Touch
            </span>
            <br />
            Leave Your Enquiry
          </h2>
          <div className="row g-4">
            <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
              <h5 className='mb-5' style={{color:'var(--HeaderColor)'}}>Get In Touch</h5>

              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 "
                  style={{ width: 50, height: 50, backgroundColor:'var(--HeaderColor)' }}
                >
                  <i className="fa fa-map-marker-alt text-white" />
                </div>
                <div className="ms-3">
                  <h5 style={{color:'var(--HeaderColor)'}}>Office</h5>
                  <p className="mb-0">
                    P.O Box 14421 Boma Road, Arusha – Tanzania </p>
                </div>
              </div>
              <div className="d-flex align-items-center mb-4">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 "
                  style={{ width: 50, height: 50, backgroundColor:'var(--HeaderColor)'  }}
                >
                  <i className="fa fa-phone-alt text-white" />
                </div>
                <div className="ms-3">
                  <h5 style={{color:'var(--HeaderColor)'}}>Mobile</h5>
                  <a href="tel:+255784994151" className="text-decoration-none " style={{color:'#7a3d3d'}}>
                    +255784994151
                  </a>
                  
                </div>
              </div>
              <div className="d-flex align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center flex-shrink-0 "
                  style={{ width: 50, height: 50, backgroundColor:'var(--HeaderColor)'  }}
                >
                  <i className="fa fa-envelope-open text-white" />
                </div>
                <div className="ms-3">
                  <h5 style={{color:'var(--HeaderColor)'}}>Email</h5>
                  <a href="mailto:booking@africantraveltour.com" className="text-decoration-none"style={{color:'#7a3d3d'}} >
                    booking@africantraveltour.com
                  </a>
                </div>
              </div>
            </div>
            {/* 
          <div className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay="0.3s">
            <iframe
              className="position-relative rounded w-100 h-100"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
              frameBorder={0}
              style={{ minHeight: 300, border: 0 }}
              allowFullScreen=""
              aria-hidden="false"
              tabIndex={0}
            />
          </div>
          */}
            <div
              className="col-lg-6 col-md-12 wow fadeInUp"
              data-wow-delay="0.5s"
            >
              <form onSubmit={handleSubmit} noValidate>
                <div className="row g-3">
                  {/* Name */}
                  <div className="col-md-6">
                    <div className="">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        placeholder="Your Name"
                        value={formData.name}
                        onChange={handleChange}
                      />
                      {errors.name && <small className="text-danger">{errors.name}</small>}

                    </div>
                  </div>

                  {/* Email */}
                  <div className="col-md-6">
                    <div className="">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}

                        className="form-control"
                        placeholder="Your Email"
                      />
                      {errors.email && (
                        <small className="text-danger">{errors.email}</small>
                      )}
                    </div>
                  </div>
                  {/* Country Code */}
                  <div className="col-md-6">
                    <div className="">
                      <select
                        name="countryCode"
                        value={formData.countryCode}
                        onChange={handleChange}
                        className="form-select me-2"
                      >
                        {countryCodes.map((c) => (
                          <option key={c.code} value={c.dial_code}>
                            {c.name} ({c.dial_code})
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Phone*/}
                  <div className="col-12">
                    <div className="">
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}

                        className="form-control"
                        placeholder="Your Phone"
                      />
                      {errors.phone && (
                        <small className="text-danger">{errors.phone}</small>
                      )}
                    </div>
                  </div>

                  {/* Arrival & Departure Date */}
                  <div className="col-md-6">
                    <label htmlFor="arrivalDate" className='text-muted'>Arrival Date</label>
                    <div className="form-floating">

                      <input
                        type="date"
                        name="arrival"
                        value={formData.arrival}

                        onChange={handleChange}

                        className="form-control"
                      />
                      {errors.arrival && (
                        <small className="text-danger">{errors.arrival}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="departureDate" className='text-muted'>Departure Date</label>
                    <div className="form-floating">
                      <input
                        type="date"
                        name="departure"
                        value={formData.departure}
                        placeholder='Departure Date'
                        onChange={handleChange}

                        className="form-control"
                      />
                      {errors.departure && (
                        <small className="text-danger">{errors.departure}</small>
                      )}
                    </div>
                  </div>

                  {/* Adults & Children */}
                  <div className="col-md-6">
                    <div className="">
                      <input
                        type="number"
                        name="adults"
                        value={formData.adults}
                        onChange={handleChange}

                        className="form-control"
                        placeholder="Adults"
                      />
                      {errors.adults && (
                        <small className="text-danger">{errors.adults}</small>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="">
                      <input
                        type="number"
                        name="children"
                        value={formData.children}
                        onChange={handleChange}

                        className="form-control"
                        placeholder="Children"
                      />
                    </div>
                  </div>
                  {/*honeyPot */}
                  <div style={{ display: "none" }}>
                    <input
                      type="text"
                      name="honeypot"
                      value={formData.honeypot}
                      onChange={handleChange}
                      tabIndex="-1"
                      autoComplete="off"
                    />
                  </div>




                  {/* Message */}
                  <div className="col-12">
                    <div className="form-floating">
                      <textarea
                        className="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        name="message"
                        style={{ height: 100 }}

                        value={formData.message}
                        onChange={handleChange}
                      />
                      <label htmlFor="message">Message</label>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <div className="col-12">
                    <button className="btn btn-primary w-100 py-3" type="submit"
                      disabled={loading}>
                      {loading ? (
                        <>
                          <i className="bi bi-arrow-repeat me-2 spin" />
                          Sending...
                        </>
                      ) : (
                        "Send Message"
                      )}
                    </button>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>
      {/* Contact End */}
    </div>
  )
}

export default Contact
